import React, { useRef } from "react";
import "./ManagePartners.css";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../../assests/leftArrow.svg";
import { useNavigate } from "react-router-dom";
import Table from "react-bootstrap/Table";
import refillEye from "../../../../assests/refillEye.svg";
import searchIcon from "../../../../assests/search.svg";
import emotions7 from "../../../../assests/emotions7.svg";
import Button from "@mui/material/Button";
import LoadingSpinner from "../../../Loading/component";
import CircularProgress from "@mui/material/CircularProgress";

const ManagePartnersComponent = (props) => {
  const navigate = useNavigate();
  const searchInputRef = useRef(null);

  const handleGoBack = () => {
    navigate("/");
  };

  const handleClearSearch = () => {
    props.handleClearSearch();
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  };
  
  // Cohort type mapping - sirf specific IDs ke liye
  const cohortTypeMapping = {
    "2": "FOFO(Franchise)",
    "4": "FOCO(City)",
    "13": "PDF"
  };

  // Function to get display type based on cohortTypeId
  const getDisplayType = (partner) => {
    // Agar cohortTypeId hai mapping mein toh mapped value do
    if (partner.cohortTypeId && cohortTypeMapping[partner.cohortTypeId]) {
      return cohortTypeMapping[partner.cohortTypeId];
    }
    // Warna partner.type ya partner.cohortTypeId do
    return partner.type || partner.cohortTypeId || '-';
  };

  return (
    <div className="manage-partners-layout">
      <Sidebar />
      
      <div className="manage-partners-content">
        {/* Header Section */}
        <div className="manage-partners-header">
          <button className="manage-partners-back-btn" onClick={handleGoBack}>
            <img src={leftArrow} alt="Back" />
          </button>
          <h2 className="manage-partners-title">Manage Partners</h2>
        </div>

        {/* Search and Add Section */}
        <div className="manage-partners-controls">
          <div className="manage-partners-search-container">
            <input
              ref={searchInputRef}
              type="search"
              className="manage-partners-search-input"
              placeholder="Search by Partner Name, ID, Cohort ID, Owner ID"
              value={props.searchValue}
              onChange={props.handleSearchInputChange}
              onKeyPress={props.handleKeyPress}
            />
            {props.searchValue ? (
              <button
                className="manage-partners-clear-btn"
                onClick={handleClearSearch}
                disabled={props.isLoading}
              >
                ×
              </button>
            ) : (
              <button
                className="manage-partners-search-btn"
                onClick={props.handleSearchSubmit}
                disabled={props.isLoading}
              >
                <img src={searchIcon} alt="Search" />
              </button>
            )}
          </div>

          <Button
            variant="contained"
            color="primary"
            className="manage-partners-add-btn"
            onClick={props.handleAddNewEntry}
            disabled={props.isLoading}
          >
            + Add New
          </Button>
        </div>

        {/* Table Section */}
        <div className="manage-partners-table-section">
          <div className="manage-partners-table-wrapper">
            <Table className="manage-partners-table" striped hover>
              <thead>
                <tr>
                  <th className="manage-partners-col-id">ID</th>
                  <th className="manage-partners-col-name">Name</th>
                  <th className="manage-partners-col-desc">Description</th>
                  <th className="manage-partners-col-type">Type</th>
                  <th className="manage-partners-col-cohort">Cohort ID</th>
                  <th className="manage-partners-col-owner">Owner ID</th>
                  <th className="manage-partners-col-actions">Actions</th>
                </tr>
              </thead>
              <tbody>
                {props.partnersList.length > 0 ? (
                  props.partnersList.map((partner) => (
                    <tr 
                      key={partner.id} 
                      className="manage-partners-table-row"
                      onClick={() => props.handleViewDetails(partner.id, partner.cohortId)}
                    >
                      <td className="manage-partners-col-id">{partner.id}</td>
                      <td className="manage-partners-col-name">{partner.name}</td>
                      <td className="manage-partners-col-desc">{partner.description}</td>
                      <td className="manage-partners-col-type">{getDisplayType(partner)}</td>
                      <td className="manage-partners-col-cohort">{partner.cohortId}</td>
                      <td className="manage-partners-col-owner">{partner.ownerId}</td>
                      <td className="manage-partners-col-actions">
                        <img
                          className="manage-partners-view-icon"
                          onClick={(e) => {
                            e.stopPropagation();
                            props.handleViewDetails(partner.id, partner.cohortId);
                          }}
                          src={refillEye}
                          alt="View Details"
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="manage-partners-empty-state">
                      <div className="manage-partners-no-data">
                        <img
                          className="manage-partners-no-data-img"
                          src={emotions7}
                          alt="No partners found"
                        />
                        <p className="manage-partners-no-data-text">
                          {props.isSearching || props.searchValue ? 
                            "No partners match your search" : 
                            "No Partners Found"}
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          {/* Load More Button - Only show when not searching */}
          {props.hasMore && !props.searchValue && !props.isSearching && (
            <div className="manage-partners-load-more-container">
              <Button
                variant="outlined"
                className="manage-partners-load-more-btn"
                onClick={props.handleLoadMore}
                disabled={props.isLoading}
              >
                {props.isLoading ? "Loading..." : "Load More"}
              </Button>
            </div>
          )}

          {/* Search Results Info */}
          {/* {props.searchValue && props.partnersList.length > 0 && (
            <div className="manage-partners-search-info">
              Showing search results for "{props.searchValue}"
            </div>
          )} */}

          {/* No Load More for Search */}
          {props.searchValue && !props.hasMore && props.partnersList.length > 0 && (
            <div className="manage-partners-no-more-info">
              No more search results
            </div>
          )}

          {/* Searching Indicator */}
          {/* {props.isSearching && (
            <div className="manage-partners-searching-indicator">
              <CircularProgress size={20} style={{ marginRight: "10px" }} />
              Searching partners...
            </div>
          )} */}
        </div>

        {/* Loading Overlay for initial load */}
        {props.isLoading && !props.isSearching && !props.searchValue && (
          <div className="manage-partners-loading-overlay">
            <LoadingSpinner />
          </div>
        )}
      </div>
    </div>
  );
};

export default ManagePartnersComponent;